<template>
  <modal v-model="isVisible">
    <div class="c-modalCard">
      <header class="c-modalCard__header">
        <h4 class="c-modalCard__title">Termo de Aceite para Instalação do Aplicativo - Amazon</h4>
        <a role="button" class="c-modalCard__close" v-on:click="isVisible = false">
          <i class="i-remove"></i>
        </a>
      </header>
      <div class="c-modalCard__body">
        <h3>Introdução</h3>
        <p>
          Ao instalar e utilizar este aplicativo, o lojista (doravante denominado “Usuário”) 
          concorda em cumprir os termos e condições descritos neste Termo de Aceite. 
          Este Termo é indispensável para a instalação e uso do aplicativo da 
          Moovin Plataforma E-commerce Ltda, em conformidade com os requisitos 
          estabelecidos pela Amazon e pela Moovin.
        </p>
        
        <h3>Compromisso com a Política de Uso Aceitável da Amazon</h3>
        <p>
          O Usuário concorda em seguir rigorosamente a Política de Uso Aceitável (AUP) 
          da Amazon, incluindo, mas não se limitando a:
        </p>
        <ul>
          <li>Não compartilhar Informações Pessoais Identificáveis (PII) de clientes ou parceiros de venda em qualquer formato (ex.: capturas de tela, e-mails ou qualquer outro meio).</li>
          <li>Abster-se de incluir dados PII em tíquetes de suporte ao cliente ou em comunicações com a Moovin.</li>
        </ul>

        <h3>Tratamento e Proteção de Dados</h3>
        <p>
          A Moovin compromete-se a:
        </p>
        <ul>
          <li>Garantir que os dados fornecidos sejam tratados em conformidade com as regulamentações de proteção de dados aplicáveis.</li>
          <li>Criptografar informações sensíveis conforme descrito na política de fluxo de dados.</li>
        </ul>
        <p>
          O Usuário, por sua vez, é responsável por:
        </p>
        <ul>
          <li>Garantir que os dados compartilhados com o marketplace Amazon e com a Moovin estejam em conformidade com as políticas de privacidade e proteção de dados.</li>
        </ul>

        <h3>Penalidades por Descumprimento</h3>
        <p>
          O descumprimento deste Termo poderá acarretar as seguintes penalidades:
        </p>
        <ul>
          <li>Suspensão do acesso ao aplicativo.</li>
          <li>Notificação à Amazon sobre práticas inadequadas, quando aplicável.</li>
          <li>Outras sanções previstas pela legislação e regulamentos aplicáveis.</li>
        </ul>

        <h3>Aceite do Termo</h3>
        <p>
          Ao prosseguir com a instalação, o Usuário declara que leu, compreendeu e concorda 
          com todos os termos e condições descritos acima. Este aceite tem força de contrato 
          legal e será utilizado como registro de conformidade com as políticas da Amazon e da Moovin.
        </p>

        <p>Data da última atualização: 03/01/2025</p>
      </div>

      <footer class="c-modalCard__footer">
        <p v-if="terms.user && terms.date">
          Termos e Políticas de Serviço aceitos por <strong>{{ terms.user }}</strong> em <strong>{{ terms.date }}</strong>.
        </p>
        <button type="button" class="btn"  v-on:click="cancel()">Sair</button>
      </footer>
    </div>
  </modal>
</template>


<script>
  export default {
    data: () => ({
      modal: null,
      isVisible: false
    }),
    props: {
      value: {
        type: Boolean,
        required: true
      },
      terms: {
        type: Object,
        required: false
      }
    },
    created () {
      this.isVisible = this.value
    },
    mounted () {
      this.modal = document.querySelector('div.c-modal')
      this.modal.onclick = (event) => {
        if (event.target === this.modal) {
          this.close()
        }
      }
      document.body.onkeyup = (event) => {
        if (event.code === 'Escape') {
          this.close()
        }
      }
    },
    methods: {
      close () {
        delete document.body.onkeyup
        delete this.modal.onclick
        this.isVisible = false
      },
      cancel () {
        this.isVisible = false
        this.checked = false
      }
    },
    watch: {
      isVisible (value) {
        this.$emit('input', value)
      },
      value (value) {
        this.isVisible = value
      }
    }
  }
</script>

<style lang="sass" scoped>
  .c-modalCard
    width: 900px
    align-content: center


  .c-modal--sm
    .c-modal__content
      max-width: 900px
      align-content: center

</style>



// WEBPACK FOOTER //
// ModalService.vue?7fd004eb